import {
  ICountry,
} from '../mobx-store/storeInterfaces/authInterface';

enum countriesIsoCodes {
  egypt = "EG",
  kenya = "KE",
  MU = "MU",
}

const convertCountriesToISOCodeString = (countries: ICountry[]) => {
  const countriesIsoCode = countries.map((country: ICountry) => country.isoCode);
  const availableCountries = countriesIsoCode.toString();
  return availableCountries;
};
export {
  countriesIsoCodes, convertCountriesToISOCodeString,
};
